import RichText from '@eneco/components/RichText/RichText';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import { DashboardLink } from './DashboardLink';

export const CompleteMoveFileCard = () => {
  const { fields } = useContent<DashboardOverviewRendering>();
  return (
    <StyledDashboardBlock>
      <RichText html={fields.completeMoveFileCard?.description.value} />
      <DashboardLink
        href={fields.completeMoveFileCard?.link.value.href}
        emphasis="high"
        target={fields.completeMoveFileCard?.link.value.target}
        trackingComponentName="complete_move_file_link"
        trackingComponentType="dashboard_link">
        {fields.completeMoveFileCard?.link.value.text}
      </DashboardLink>
    </StyledDashboardBlock>
  );
};
